// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from './client.gen';
export const pingControllerPing = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api/v3/healthcheck/ping-nest',
        ...options
    });
};
export const createPageProspectControllerCreateProspect = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/page/{id}/prospect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const listPortalExportsControllerListPortalExports = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/page/{id}/portals/exports',
        ...options
    });
};
export const deletePortalUrlControllerDeletePortalUrl = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/portals/{portalName}/url',
        ...options
    });
};
export const setPortalUrlControllerSetPortalUrl = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/portals/{portalName}/url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const listPortalUrlsControllerListPortalUrls = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/page/{propertyId}/portals/urls',
        ...options
    });
};
export const setPortalExportControllerSetPortalExport = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/portals/{portalName}/export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const deleteProjectDeputyControllerDeleteProjectDeputy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/projectDeputy',
        ...options
    });
};
export const setProjectDeputyControllerSetProjectDeputy = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/projectDeputy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const deleteProjectManagerControllerDeleteProjectManager = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/projectManager',
        ...options
    });
};
export const setProjectManagerControllerSetProjectManager = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/projectManager',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const deleteLocalExpertControllerDeleteLocalExpert = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/localExpert',
        ...options
    });
};
export const setLocalExpertControllerSetLocalExpert = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/localExpert',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const deleteClientAdvisorControllerDeleteClientAdvisor = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/clientAdvisor',
        ...options
    });
};
export const setClientAdvisorControllerSetClientAdvisor = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/clientAdvisor',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const generateEstimationControllerGenerateEstimation = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/estimation/{estimationId}/generate',
        ...options
    });
};
export const missingActivitiesSendEmailControllerSendEmail = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/api/v3/page/missingActivities/sendEmail',
        ...options
    });
};
export const sendPostVisitFeedbackEmailsControllerSendPostVisitFeedbackEmails = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/api/v3/deal/sendPostVisitFeedbackEmails',
        ...options
    });
};
export const createDealControllerCreateDeal = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/deal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const deleteDealControllerDeleteDeal = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/deal/{id}',
        ...options
    });
};
export const deleteOtherTeamMemberControllerDeleteOtherTeamMember = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/team-members/other-team-members/{otherTeamMemberId}',
        ...options
    });
};
export const updateOtherTeamMemberControllerUpdateOtherTeamMember = (options) => {
    return (options.client ?? _heyApiClient).patch({
        url: '/api/v3/page/{propertyId}/team-members/other-team-members/{otherTeamMemberId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const addOtherTeamMemberControllerAddOtherTeamMember = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/page/{propertyId}/team-members/other-team-members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const setPageContactControllerSetPageContact = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/page/{propertyId}/contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const startPageContactAvatarUploadControllerStartPageContactAvatarUpload = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/page/{propertyId}/contact/avatarUpload',
        ...options
    });
};
export const completePageContactAvatarUploadControllerCompletePageContactAvatarUpload = (options) => {
    return (options.client ?? _heyApiClient).patch({
        url: '/api/v3/page/{propertyId}/contact/avatarUpload/{contactAvatarUploadId}/complete',
        ...options
    });
};
export const deletePageContactAvatarControllerDeletePageContactAvatar = (options) => {
    return (options.client ?? _heyApiClient).delete({
        url: '/api/v3/page/{propertyId}/contact/avatar/{contactAvatarId}',
        ...options
    });
};
export const sendInvitationEmailControllerSendInvitationEmail = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/deal/{dealId}/sendInvitationEmail/{visitId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const createRatingControllerCreateRating = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/v3/rate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const getRatingControllerGetRating = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/rate/{userId}',
        ...options
    });
};
export const listRatingsControllerListRatings = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/rate/{quantity}/{offset}',
        ...options
    });
};
export const getTokenControllerGetToken = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/authentication/getToken',
        ...options
    });
};
export const createPageControllerCreatePage = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/api/v3/page',
        ...options
    });
};
export const listOrganizationStructureControllerListOrganizationStructure = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/v3/company/{companyId}/organization-structure',
        ...options
    });
};
export const getPartnerPortfolioControllerGetPortfolioProperties = (options) => {
    return (options.client ?? _heyApiClient).get({
        url: '/api/buy/v4/partners/{partnerStub}/portfolioproperties',
        ...options
    });
};
export const setPropertyLocationMarkerPinControllerSetLocationPin = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/property/{propertyId}/location/marker-pin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const setPropertyLocationMarkerPinControllerAutoSetLocationPin = (options) => {
    return (options.client ?? _heyApiClient).put({
        url: '/api/v3/property/{propertyId}/location/marker-pin/by-address',
        ...options
    });
};
